import AddCollection from './AddCollection';

export default AddCollection;
